import ContractStatementUseCase from "@domains/useCases/Reports/ContractReport/ContractStatement";
import ContractStatementPDFUseCase from "@domains/useCases/Reports/ContractReport/ContractStatementPDF";
import ContractEmailUseCase from "@domains/useCases/Reports/ContractReport/ContractEmailUseCase";
import ContractStatementViewPDF from "@domains/useCases/Reports/ContractReport/ContractStatementViewPDF";
import ContractCommodityUseCase from "@domains/useCases/Reports/ContractReport/ContractCommodity";
export default (repositories) => {
    return {
        contract: new ContractStatementUseCase(repositories.contract),
        contractPDF: new ContractStatementPDFUseCase(repositories.contract),
        contractEmail: new ContractEmailUseCase(repositories.contract),
        contractViewPDF: new ContractStatementViewPDF(repositories.contract),
        contractCommodity: new ContractCommodityUseCase(repositories.contract),
    };
};
